/** @module csi/authentication/AuthenticationProvider */
define([
    "dojo/_base/declare",
    "dojo/_base/lang"
], function(declare,lang) {

    return declare(null, {
        /**
         * Unique type of authentication method.
         * It is equal to the type specified in pi-configuration.properties on the server.
         */
        type: null,

        /**
         * Is this authentication method set up per user basis?
         * If so, UI will create a multi-step process:
         * First, it asks for username,
         * Then, it issues a request to the server to check
         * what authentication methods are enabled for the user.
         * Finally, UI creates necessary fields for enabled methods.
         */
        setUpPerUser: false,

        /**
         * Mix-in properties from the parameter object
         */
        constructor: function(props) {
            lang.mixin(this, props);
        },

        /**
         * Get field definitions for UI.
         * Each field must be have the following format:
         * {
         *   id: unique id of field,
         *   type: HTML input field type. "password" by default
         *   label: optional field with label, locale.resource(id) will be used if label is not specified,
         *   value: an initial value of the field. Empty by default
         *   autocomplete: should browser autocomplete the field. false by default
         *   readOnly: field is read-only. false by default
         *   onClick: event handler for "click" event if the input type is "button"
         * }
         */
        getFieldDefinitions: function() {
            return [];
        },

        /**
         * The function is called before UI is about to call a server with a login request
         */
        preLogin: function(/*Hash*/formValues) {
        }
    });
});